import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { money } from "@/context/StoreContext";
import { AdminCard } from "./AdminLayout";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DeleteButton, useSelection, BulkBar } from "./ImageUpload";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [detail, setDetail] = useState(null);
  const { sel, setSel, toggle, toggleAll, allChecked } = useSelection(list);
  const load = () => api.get("/admin/customers").then((r) => { setList(r.data); setSel([]); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const bulkDelete = async () => { await api.post("/admin/customers/bulk-delete", { ids: sel }); load(); };
  const open = async (id) => { const r = await api.get(`/admin/customers/${id}`); setDetail(r.data); };
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Customers</h1>
      <BulkBar count={sel.length} label="customer" onDelete={bulkDelete} testId="customers-bulk-delete" />
      <AdminCard className="overflow-x-auto p-0">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-sharoa-ivory text-left text-xs uppercase text-sharoa-muted"><tr><th className="py-3 px-4"><input type="checkbox" data-testid="customers-select-all" checked={allChecked} onChange={toggleAll} className="accent-sharoa-rose" /></th>{["Name", "Email", "Phone", "Orders", "Total Spent", "Last Order", ""].map((h, i) => <th key={i} className="py-3 px-4">{h}</th>)}</tr></thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} onClick={() => open(c.id)} className={`border-t border-sharoa-line hover:bg-sharoa-pale/40 cursor-pointer ${sel.includes(c.id) ? "bg-sharoa-pale/60" : ""}`}>
                <td className="py-3 px-4" onClick={(e) => e.stopPropagation()}><input type="checkbox" data-testid={`select-customer-${c.id}`} checked={sel.includes(c.id)} onChange={() => toggle(c.id)} className="accent-sharoa-rose" /></td>
                <td className="py-3 px-4">{c.name}</td>
                <td className="py-3 px-4">{c.email}</td>
                <td className="py-3 px-4">{c.phone || "—"}</td>
                <td className="py-3 px-4">{c.order_count}</td>
                <td className="py-3 px-4 font-mono">{money(c.total_spent)}</td>
                <td className="py-3 px-4">{c.last_order ? new Date(c.last_order).toLocaleDateString("en-IN") : "—"}</td>
                <td className="py-3 px-2"><DeleteButton label="customer" testId={`delete-customer-${c.id}`} onDelete={async () => { await api.delete(`/admin/customers/${c.id}`); load(); }} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <p className="p-6 text-sharoa-muted text-sm">No customers yet.</p>}
      </AdminCard>
      <Dialog open={!!detail} onOpenChange={(v) => !v && setDetail(null)}>
        <DialogContent className="bg-white max-h-[90vh] overflow-y-auto">
          {detail && <>
            <DialogHeader><DialogTitle className="font-serif text-2xl">{detail.name}</DialogTitle></DialogHeader>
            <p className="text-sm text-sharoa-muted">{detail.email} · {detail.phone || "no phone"}</p>
            <div className="grid grid-cols-3 gap-3 text-center my-3">
              <div className="bg-sharoa-ivory p-3"><p className="font-serif text-xl">{detail.orders?.length || 0}</p><p className="text-xs text-sharoa-muted">Orders</p></div>
              <div className="bg-sharoa-ivory p-3"><p className="font-serif text-xl">{detail.returns?.length || 0}</p><p className="text-xs text-sharoa-muted">Returns</p></div>
              <div className="bg-sharoa-ivory p-3"><p className="font-serif text-xl">{detail.reviews?.length || 0}</p><p className="text-xs text-sharoa-muted">Reviews</p></div>
            </div>
            <h4 className="font-serif text-lg">Recent Orders</h4>
            {(detail.orders || []).slice(0, 5).map((o) => <div key={o.id} className="flex justify-between text-sm border-b border-sharoa-line py-1.5"><span className="font-mono">{o.order_number}</span><span>{money(o.total)}</span><span className="capitalize text-sharoa-muted">{o.status}</span></div>)}
            <h4 className="font-serif text-lg mt-3">Addresses</h4>
            {(detail.addresses || []).map((a) => <p key={a.id} className="text-xs text-sharoa-muted">{a.house}, {a.street}, {a.city} — {a.pincode}</p>)}
          </>}
        </DialogContent>
      </Dialog>
    </div>
  );
}
